<template>
  <AccessRequestsTable
    :rows="accessRequests"
    :loading="isLoading"
    :has-more-items="hasNextPage"
    :search-query="searchQuery"
    :show-row-actions="false"
    :active="(row) => route.params.accessRequestId === row.id"
    @search="onSearch"
    @load="fetchNextPage"
    @click-row="onClickRow"
  />
</template>

<script setup lang="ts">
import { AccessRequest } from '@infuse/api/iam/access-request';
import { Organisation } from '@infuse/api/iam/organisation';
import { useAccessRequests } from '@infuse/iam/access-request/queries';
import { AccessRequestsTable } from '@infuse/iam/access-request/ui';
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps<{
  model: Organisation;
}>();

const organisationId = ref<string | undefined>(props.model?.id);

watch(
  () => props.model?.id,
  (id) => (organisationId.value = id),
  { immediate: true }
);

const { accessRequests, isLoading, hasNextPage, fetchNextPage, searchQuery } = useAccessRequests({
  targetOrganisationId: organisationId,
  enabled: () => !!organisationId.value
});

function onSearch(query: string): void {
  searchQuery.value = query;
}

function onClickRow(row: AccessRequest): void {
  router.push({
    name: 'organisation.access-requests.details',
    params: { id: organisationId.value, accessRequestId: row.id }
  });
}
</script>
